module.exports = __webpack_public_path__ + "static/media/loading9.79f0ac8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading9.png
// module id = 194
// module chunks = 0